module.exports = __webpack_public_path__ + "static/img/BeianIcon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/BeianIcon.png
// module id = BMxZ
// module chunks = 0